// extracted by mini-css-extract-plugin
export default {"root":"Title_root__FXTBw","primary":"Title_primary__DqHRD","secondary":"Title_secondary__zniSm","h1":"Title_h1__kBPm0","h2":"Title_h2__6cb+l","h3":"Title_h3__Ddvng"};